<template>
  <v-app>
    <v-main>
      <router-view/>
      <notifications height="600" width="600" color="success" position="bottom right" group="foo" />
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
